import Vue from 'vue'
import Vuex from 'vuex'

import antragsformular from '@/store/modules/antragStore/antragsformular'
import aenderungsformular from '@/store/modules/aenderungsStore/aenderungsformular'
import uebernahmeformular from '@/store/modules/uebernahmeStore/uebernahmeformular'
import dokumentenformular from '@/store/modules/dokumentenStore/dokumentenformular'
import person from '@/store/modules/antragStore/person'
import antragstellerAnschrift from '@/store/modules/antragStore/antragstellerAnschrift'
import bevollmaechtigOrgAnschrift from "@/store/modules/antragStore/bevollmaechtigOrgAnschrift"
import versandAnschrift from "@/store/modules/antragStore/versandAnschrift"
import datein from "@/store/modules/dateien"
import fahrzeugDaten from "@/store/modules/antragStore/fahrzeugDaten"
import wmiDokument from "@/store/modules/antragStore/wmiDokument"
import nezodaten from "@/store/modules/nezodaten"
import angabenZurAenderung from "@/store/modules/aenderungsStore/angabenZurAenderung"
import loggedin from "@/store/modules/loggedin"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {

  },
  actions: {

  },
  modules: {
    antragsformular: antragsformular,
    aenderungsformular: aenderungsformular,
    uebernahmeformular: uebernahmeformular,
    dokumentenformular: dokumentenformular,
    person: person,
    antragstellerAnschrift: antragstellerAnschrift,
    bevollmaechtigOrgAnschrift: bevollmaechtigOrgAnschrift,
    versandAnschrift: versandAnschrift,
    datein: datein,
    fahrzeugDaten: fahrzeugDaten,
    wmiDokument: wmiDokument,
    angabenZurAenderung: angabenZurAenderung,
    loggedin: loggedin,
    nezodaten: nezodaten
  }
})
